import React from "react";
import { Title, Text} from "@mantine/core";
import Signup from "../components/Signup";
import { Container } from "react-bootstrap";
import { Navigate } from "react-router-dom";

function SignupPage() {
  if (localStorage.getItem("accessToken")) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <div className="homeText">
        <Title className="title" align="center">Cardify</Title>
        <Text align="center">A simple flashcard app to help you study</Text>
      </div>

      <Container
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh", height: "500px" }}
      >
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Signup />
        </div>
      </Container>
    </>

  );
}

export default SignupPage;
